"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Navigation_1 = require("../Navigation");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var lodash_1 = require("lodash");
var SettingsDropdown = (function (_super) {
    __extends(SettingsDropdown, _super);
    function SettingsDropdown() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.isSettingsDropdownOpen = false;
        _this.isMobileViewport = false;
        _this.settingsItems = [
            {
                name: "Profile",
                adminOnly: false,
                onClick: function () {
                    _this.props.$state.go("settings", { section: "profile" });
                },
            },
            {
                name: "Manage Team",
                adminOnly: false,
                onClick: function () {
                    _this.props.$state.go("settings", { section: "users" });
                },
            },
            {
                name: "Brand setup",
                adminOnly: true,
                onClick: function () {
                    _this.props.openBrandSetup();
                },
            },
            {
                name: "Add Integrations",
                adminOnly: true,
                onClick: function () {
                    _this.props.$state.go("settings", { section: "integrations" });
                },
            },
            {
                name: "Account Settings",
                adminOnly: true,
                onClick: function () {
                    _this.props.$state.go("settings", { section: "account" });
                },
            },
            {
                name: "Product Updates",
                adminOnly: false,
                onClick: function () {
                    window.open("https://team.qwilr.com/Qwilr-Product-Updates-ZmP5Cml2THGA");
                },
            },
            {
                name: "Log Out",
                adminOnly: false,
                onClick: function () {
                    if (typeof Intercom !== "undefined" && Intercom) {
                        Intercom("shutdown");
                    }
                    window.location = "".concat(_this.props.publicApiBaseUrl, "/logout");
                },
                showOnMobile: true,
            },
        ];
        _this.handleViewportResize = (0, lodash_1.debounce)((0, mobx_1.action)(function () {
            _this.isMobileViewport = window.innerWidth < DISABLE_SETTINGS_ACCESS_BREAKPOINT;
        }), 750);
        return _this;
    }
    SettingsDropdown.prototype.componentDidMount = function () {
        this.onClickOutside = new utils_1.OnClickOutside([".".concat(Navigation_1.BASE_CLASS_NAME, "__settings")], this.hideSettingsDropdown);
        window.addEventListener("resize", this.handleViewportResize);
        this.handleViewportResize();
    };
    SettingsDropdown.prototype.componentWillUnmount = function () {
        this.onClickOutside.stopListening();
        window.removeEventListener("resize", this.handleViewportResize);
    };
    SettingsDropdown.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { isOpen: this.isSettingsDropdownOpen, button: react_1.default.createElement("button", { className: "".concat(Navigation_1.BASE_CLASS_NAME, "__settings center"), onClick: this.toggleSettingsDropdown },
                react_1.default.createElement(kaleidoscope_1.Avatar, { firstName: this.props.user.firstName, lastName: this.props.user.lastName }),
                react_1.default.createElement(icons_1.ChevronDown, { className: "".concat(Navigation_1.BASE_CLASS_NAME, "__settings-down-icon"), size: icons_1.IconSize.Small })), className: "".concat(Navigation_1.BASE_CLASS_NAME, "__settings-dropdown") }, this.settingsItems
            .filter(function (item) { return item.showOnMobile || !_this.isMobileViewport; })
            .map(function (settingsItem) {
            if (_this.props.rolesService.isAdmin(_this.props.user) || !settingsItem.adminOnly) {
                var itemProps = {
                    key: settingsItem.name,
                    onClick: settingsItem.onClick,
                    children: settingsItem.name,
                };
                if (settingsItem.name !== "Log Out") {
                    return react_1.default.createElement(kaleidoscope_1.OptionMenuItem, __assign({}, itemProps));
                }
                else {
                    return (react_1.default.createElement(react_1.default.Fragment, { key: "separator-group" },
                        !_this.isMobileViewport && react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, { key: "separator" }),
                        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, __assign({}, itemProps))));
                }
            }
        })));
    };
    SettingsDropdown.prototype.toggleSettingsDropdown = function () {
        this.isSettingsDropdownOpen = !this.isSettingsDropdownOpen;
        if (this.isSettingsDropdownOpen) {
            this.onClickOutside.startListening();
        }
        else {
            this.onClickOutside.stopListening();
        }
    };
    SettingsDropdown.prototype.hideSettingsDropdown = function () {
        this.isSettingsDropdownOpen = false;
        this.onClickOutside.stopListening();
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SettingsDropdown.prototype, "isSettingsDropdownOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SettingsDropdown.prototype, "isMobileViewport", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SettingsDropdown.prototype, "toggleSettingsDropdown", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SettingsDropdown.prototype, "hideSettingsDropdown", null);
    SettingsDropdown = __decorate([
        mobx_react_1.observer
    ], SettingsDropdown);
    return SettingsDropdown;
}(react_1.default.Component));
exports.default = SettingsDropdown;
var DISABLE_SETTINGS_ACCESS_BREAKPOINT = 500;
